import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageBanner = ({ title, subtitle, crumbs = [] }) => {
  return (
    <section className="section-navy relative overflow-hidden pt-36 pb-16 md:pt-40 md:pb-20">
      <div className="pointer-events-none absolute -right-24 top-0 h-72 w-72 rounded-full bg-white/[0.04] blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <nav className="mb-5 flex items-center gap-2 text-sm text-white/50">
          <Link to="/" className="transition-colors hover:text-white">
            Home
          </Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="h-4 w-4" />
              {c.to ? (
                <Link to={c.to} className="transition-colors hover:text-white">
                  {c.label}
                </Link>
              ) : (
                <span className="text-white/80">{c.label}</span>
              )}
            </span>
          ))}
        </nav>
        <h1 className="max-w-3xl text-4xl font-semibold tracking-tight text-white md:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-lg font-light text-white/70">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageBanner;
